module.exports = __webpack_public_path__ + "img/header_tablet.9ea5de1f.svg";